// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { SystemListApiParameter, SystemListCollectionModel } from "@werner/App/Services/SystemListService";
import { Draft } from "immer";

export type SystemListState = {
    [key: string]: SystemListCollectionModel;
};

const initialSystemListState: SystemListState = {};

const xSystemList = createTypedReducerWithImmer(initialSystemListState, {
    "xSystemLists/CompleteLoadSystemList": (
        draft: Draft<SystemListState>,
        action: { parameter: SystemListApiParameter; systemList: SystemListCollectionModel },
    ) => {
        draft[action.parameter.systemListName] =
            action.systemList instanceof Array
                ? { values: [], systemListName: action.parameter.systemListName, systemListDescription: "" }
                : action.systemList;
    },
});

(reducers as any).xSystemList = xSystemList;

export type xSystemListReducers = {
    xSystemList: SystemListState;
};
